<template>
  <div>
    <div
      v-if="activeDocumentDetails.status === $STATUS.IN_DISPUTE"
      class="attention-box flex items-center my-5"
    >
      <attention-icon class="mr-2" />
      <p class="text-sm text" style="word-break: normal">
        {{ activeDocumentDetails.disputeReason }}
      </p>
    </div>
    <div
      v-for="(questionnaire, index) in transferQuestionaire"
      :key="index"
      class="mb-4 border mt-3 rounded-lg"
      test-id="questionnaireTest"
    >
      <div class="font-normal mb-2 border-b p-4">
        Question {{ index + 1 }}:
        <span class="pl-4 capitalize text-md font-normal">
          {{ questionnaire.question }} ?
        </span>
      </div>

      <div class="bg-white p-5">
        <div>
          <div
            class="mb-2 cursor-pointer px-2.5 flex items-center justify-between"
          >
            <div
              class="text-xs font-normal rounded-full px-3 py-1.5"
              :class="
                questionnaire.answer
                  ? 'bg-info-subtle text-primary'
                  : 'attention-class'
              "
            >
              {{ questionnaire.answer ? 'Answer' : 'Unaswered' }}
            </div>
            <!-- to get back to it  -->
            <!-- <div class="flex items-center">
              <p class="pr-2">Answered:</p>
              <span class="font-normal capitalize">{{
                parseRelativeTime(questionnaire.answeredAt)
              }}</span>
            </div> -->
          </div>
        </div>
        <div class="font-semibold mt-2 text-md" v-if="questionnaire.answer">
          {{ questionnaire.answer }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormatServerName, ParseRelativeTime } from '@/utils/helpers.js'
export default {
  props: {
    activeDocumentDetails: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    parseRelativeTime (time) {
      return ParseRelativeTime(time)
    },
    formatServerName (val) {
      return FormatServerName(val)
    }
  },
  components: {
    AttentionIcon: () => import('@/assets/v2/icons/AttentionIcon.vue')
  },
  computed: {
    transactionInfo () {
      return this.$store.state.transactions.transactionDetails
    },
    transferDocuments () {
      return this.transactionInfo.transferDocument || []
    },
    transferQuestionaire () {
      return this.activeDocumentDetails.questionnaire
    }
  }
}
</script>
<style scoped>
.attention-box {
  background: #fce8ec;
  border: 1px solid #df1642;
  border-radius: 4px;
  padding: 8px 10px 8px 18px;
}
.text {
  color: #9c0f2e;
}
>>> .el-input__inner {
  border-radius: 0.6rem;
  height: 3.5rem;
  padding-left: 1rem !important;
}
>>> .el-input__inner:hover,
>>> .el-input__inner:focus,
>>> .el-input__inner:active {
  border-color: var(--color-primary);
}
>>> .el-image {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 20px 40px;
}
>>> input#fileInput.el-input__inner {
  color: transparent;
}
@media screen and (max-width: 768px) {
  >>> .el-form-item__label,
  .small-text,
  .browseButton,
  .el-input__inner {
    font-size: 0.75rem;
  }
}
</style>
